interface OrdersChartProps {
  data: { label: string; value: number }[]
}

export function OrdersChart({ data }: OrdersChartProps) {
  const max = Math.max(...data.map((d) => d.value), 1)
  const total = data.reduce((s, d) => s + d.value, 0)
  const avg = Math.round(total / data.length)

  return (
    <div className="bg-surface border border-border rounded-xl shadow-card p-5">
      <div className="flex items-start justify-between mb-5 gap-3 flex-wrap">
        <div>
          <h3 className="font-semibold text-text">Đơn hàng 7 ngày qua</h3>
          <p className="text-xs text-muted mt-0.5">Tổng {total} đơn — trung bình {avg} đơn/ngày</p>
        </div>
        <div className="inline-flex items-center gap-2 text-xs">
          <span className="w-3 h-3 rounded-sm bg-gradient-to-t from-brand-600 to-brand-400" />
          <span className="text-muted">Số đơn</span>
        </div>
      </div>

      <div className="flex items-end gap-3 h-[220px]">
        {data.map((d) => {
          const pct = (d.value / max) * 100
          return (
            <div key={d.label} className="flex-1 flex flex-col items-center gap-2 group">
              <div className="w-full flex-1 flex items-end">
                <div
                  className="w-full rounded-t-md bg-gradient-to-t from-brand-600 to-brand-400 relative transition-all group-hover:from-brand-700 group-hover:to-brand-500"
                  style={{ height: `${pct}%`, minHeight: '4px' }}
                >
                  <div className="absolute -top-7 left-1/2 -translate-x-1/2 bg-slate-900 text-white text-[11px] font-semibold px-2 py-0.5 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none whitespace-nowrap">
                    {d.value} đơn
                  </div>
                </div>
              </div>
              <div className="text-xs text-muted font-medium">{d.label}</div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
